import { render, staticRenderFns } from "./addUsuarios.vue?vue&type=template&id=36e3f6d4&scoped=true"
import script from "./addUsuarios.vue?vue&type=script&lang=js"
export * from "./addUsuarios.vue?vue&type=script&lang=js"
import style0 from "./addUsuarios.vue?vue&type=style&index=0&id=36e3f6d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e3f6d4",
  null
  
)

export default component.exports